import PropTypes from "prop-types";

const IntolerancesType = PropTypes.exact({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
});

export const IntoleranceFiltersTypes = {
    intolerance: IntolerancesType,
    onFilter: PropTypes.func.isRequired,
    selectedFilters: PropTypes.arrayOf(PropTypes.number.isRequired),
};

export const IntoleranceFiltersOptionsTypes = {
    open: PropTypes.bool.isRequired,
    selectedFilters: PropTypes.arrayOf(PropTypes.number.isRequired),
    onSelect: PropTypes.func,
    handleClose: PropTypes.func,
    handleClear: PropTypes.func,
    intolerances: PropTypes.func,
    onFilter: PropTypes.func,
};
